import React, { useEffect, useState } from "react";
import Header from "../../Header";
import { useNavigate } from "react-router-dom";
import Loading from "../../pages/Loading/Loading";
import { useDispatch } from "react-redux";
import { addAddress, clearAddresses } from "../../../slices/managerSlice";
import ConnectionError from "../../ConnectionError/ConnectionError";
import { fetchWithTimeout } from "../../../utils/fetchWithTimeout";

function ManagerAddressees() {
  const [content, setContent] = useState();
  const [loadError, setLoadError] = useState(null);
  const [retryKey, setRetryKey] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearAddresses());
  }, [dispatch]);

  useEffect(() => {
    async function tryGetAddresses() {
      try {
        const response = await fetchWithTimeout(
          `https://api-erkon.tech/mobile/hs/ObmenMP/AddressListPWA`,
          {
            headers: {
              token: localStorage.getItem("tokenMANAGER"),
            },
            method: "POST",
          },
        );

        if (response.status === 200) {
          const data = await response.json();

          if (Array.isArray(data)) {
            setContent(data);
            setLoadError(null);
          } else {
            setLoadError('invalid');
          }
        } else if (response.status === 401) {
          localStorage.removeItem('tokenMANAGER');
          window.location.replace('/login');
        } else {
          setLoadError(response.status);
        }
      } catch (e) {
        setLoadError('network');
      }
    }

    tryGetAddresses();
  }, [retryKey]);

  const redirect = (ticket) => {
    dispatch(addAddress(ticket.uid));
    navigate("prorabs", {
      state: {
        counterpart: ticket.receiver,
        address: ticket.name,
        addressUID: ticket.uid,
      },
    });
  };
  if (content) {
    return (
      <>
        <Header
          headerTitle={"Адрес"}
          backRedirect={-1}
          search={true}
          searchValue={searchInput}
          setSearchInput={setSearchInput}
        />
        <div className="contentContainer">
          <div className="contentFields">
            {content
              .filter((ticket) =>
                ticket.name
                  .toLowerCase()
                  .includes(searchInput.toLocaleLowerCase()),
              )
              .map((ticket, index) => {
                return (
                  <div key={index} className="contentTicket">
                    <div
                      onClick={() => redirect(ticket)}
                      className="boxContaienr"
                    >
                      <span className="phoneTxt">{ticket.receiver}</span>
                      <span className="contentTxt">{ticket.name}</span>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </>
    );
  } else {
    return loadError
      ? <ConnectionError status={loadError} onRetry={() => { setLoadError(null); setRetryKey(key => key + 1); }} />
      : <Loading />;
  }
}

export default ManagerAddressees;
